export const ESTADOS_PAGO = {
  NO_PAGADO: 0,
  PAGADA: 1,
  PARCIALMENTE_PAGADA: 2,
} as const

export type EstadosPagoType = (typeof ESTADOS_PAGO)[keyof typeof ESTADOS_PAGO]
